import React from "react";
import { ResourceContext } from "./resource-context";
import { FileObject, isFileObject } from "@citychallenge/common";
import { FileResolver } from "../files/file-resolver";
import { ImageSource } from "./image-source";

interface ResourceManagerProps {
  resourcePath: string;
}
export class ResourceManager extends React.Component<ResourceManagerProps> {
  private fileResolver = new FileResolver(this.props.resourcePath);
  private contextDefault = {
    available: true,
    resolveFile: (file?: FileObject) => {
      const resolved = this.fileResolver.resolve(file);
      return resolved;
    },
    resolveImageProp: (imageProp?: FileObject | ImageSource) => {
      if (isFileObject(imageProp)) return this.fileResolver.resolve(imageProp);
      return imageProp as ImageSource | undefined;
    },
  };

  public render() {
    return (
      <ResourceContext.Provider value={this.contextDefault}>
        {this.props.children}
      </ResourceContext.Provider>
    );
  }
}
